import React from "react";
import { motion, animate } from "framer-motion";
import { Text, useBreakpointValue, useMediaQuery } from "@chakra-ui/react";

const ScrollToTop = () => {
  const smoothScrollToTop = () => {
    animate(window.scrollY, 0, {
      type: "spring",
      stiffness: 100,
      damping: 20,
      onUpdate: (value) => window.scrollTo(0, value),
      duration: 0.8,
    });
  };

  const buttonSize = useBreakpointValue({
    base: "35px",
    md: "40px",
    lg: "50px",
  });

  const [isLg] = useMediaQuery("(min-width: 992px)");

  return (
    <motion.button
      onClick={smoothScrollToTop}
      style={{
        position: "fixed",
        bottom: "2rem",
        right: "2rem",
        zIndex: 50,
        background: "rgba(255, 255, 255, 0.2)",
        backdropFilter: "blur(10px)",
        border: "1px solid rgba(255, 255, 255, 0.3)",
        borderRadius: "50%",
        width: buttonSize,
        height: buttonSize,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
      }}
      initial={{ opacity: 0, rotate: isLg ? -30 : 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.8 }}
      whileHover="hover"
      whileTap={{ scale: 0.9 }}
      variants={{
        hover: { scale: 1.1, rotate: 0 },
      }}
    >
      <motion.div
        variants={{
          hover: { y: -5 },
        }}
        transition={{ type: "spring", stiffness: 300, damping: 20 }}
      >
        <Text fontSize={{base:"md",md:"2xl"}} color="white">
          ↑
        </Text>
      </motion.div>
    </motion.button>
  );
};

export default ScrollToTop;
